webpackJsonp([33679904168046],{

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function () {
	  if (typeof window !== 'undefined') {
	    var newURL = window.location.href
	    // Different host
	    .replace(/^https?:\/\/[^/]+/, 'https://enzymejs.github.io')
	    // Remove trailing slash, to help redirects from pages with file
	    // extensions work
	    .replace(/(\.[a-z]+)\/$/, '$1');
	    window.location.replace(newURL);
	  }
	
	  return _react2['default'].createElement(
	    'p',
	    null,
	    'Enzyme has moved. Redirecting now to ',
	    _react2['default'].createElement(
	      'a',
	      { href: 'https://enzymejs.github.io' },
	      'enzymejs.github.io'
	    ),
	    '...'
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-enzyme-page-jsx-ae03cea5c89270736f2f.js